<template>
  <v-footer class="white tk-pragmatika text-h6 font-weight-regular">
    <v-container>
      <v-row justify="space-between" class="mx-16 px-2 py-5">
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="block-title">TBC</div>
          <div class="content">
            <div class="address">
              <p>215 Avenue François Verdier</p>
              <p>81 000 ALBI</p>
              <p>FRANCE</p>
              <hr />
              <p>14 Avenue Jean Monnet</p>
              <p>Bourran</p>
              <p>12 000 RODEZ</p>
              <p>FRANCE</p>
            </div>
            <hr />
            <div>
              <router-link
                class="text-decoration-none"
                :to="$store.state.auth.user ? {name: 'Support'} : {name: 'Welcome Support'}"
              >{{ $t('Support') }}</router-link>
            </div>
            <hr />
            <div>
              <a
                class="text-decoration-none"
                href="https://www.solutions-tbc.fr"
                target="_blank"
              >www.solutions-tbc.fr</a>
            </div>
            <hr />
            <div>
              <a
                class="text-decoration-none"
                href="https://www.apptbc.com"
                target="_blank"
              >www.apptbc.com</a>
            </div>
            <hr class="d-md-none" />
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3" class="d-flex flex-column justify-start align-center">
          <div class="text-uppercase">{{ $t('Follow us') }}</div>
          <v-row class="flex-grow-0">
            <v-col>
              <a
                class="text-decoration-none"
                href="https://www.facebook.com/tbcsolutions/"
                target="_blank"
              >
                <v-icon color="primary" x-large>mdi-facebook</v-icon>
              </a>
            </v-col>
            <v-col>
              <a
                class="text-decoration-none"
                href="https://twitter.com/solutionstbc"
                target="_blank"
              >
                <v-icon color="primary" x-large>mdi-twitter</v-icon>
              </a>
            </v-col>
            <v-col>
              <a
                class="text-decoration-none"
                href="https://www.linkedin.com/company/solutionstbc/"
                target="_blank"
              >
                <v-icon color="primary" x-large>mdi-linkedin</v-icon>
              </a>
            </v-col>
            <v-col>
              <a
                class="text-decoration-none"
                href="https://www.youtube.com/channel/UCkxUhK8BBLeIhbLb57RoiSw"
                target="_blank"
              >
                <v-icon color="primary" x-large>mdi-youtube</v-icon>
              </a>
            </v-col>
          </v-row>
          <hr class="w-100" />
          <a href="https://www.apptbc.com">
            <v-img
              src="@/assets/logo-tbc-solutions.png"
              alt="Logo TBC Solutions"
              width="200px"
              contain
              class="flex-grow-0"
            ></v-img>
          </a>
          <hr class="w-100" />
          <v-img
            src="@/assets/xerox.png"
            alt="Logo Xerox"
            width="150px"
            contain
            class="flex-grow-0"
          ></v-img>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.w-100 {
  width: 100%;
}
</style>